import React from "react";
import {FormattedMessage} from "react-intl";

export default (props) => {

  return (
    <h1 className="page-title">
      <FormattedMessage id='terms.title' defaultMessage='Terms and conditions'/>
    </h1>
  );
}
